import { createClient } from '@supabase/supabase-js';

/**
 * Cliente do painel.
 *
 * Usa a **chave publicável**, igual ao site. O painel não tem poder especial por ter uma chave
 * diferente: quem autoriza é a RLS, que pergunta `is_admin()` — ou seja,
 * `app_metadata.role = 'admin'`, marcado à mão no painel do Supabase (regra 3).
 *
 * O service role (`sb_secret_...`) nunca entra aqui. Quando o painel precisar de poder de
 * servidor (subir vídeo, reembolsar), ele chama a Edge Function correspondente
 * (`bunny-upload`, `refund`), que é quem guarda o segredo.
 */
const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!url || !key) {
  throw new Error(
    'Faltam VITE_SUPABASE_URL e VITE_SUPABASE_PUBLISHABLE_KEY. Veja .env.example e docs/05-contas-e-chaves.md.',
  );
}

export const supabaseClient = createClient(url, key, {
  auth: { persistSession: true, autoRefreshToken: true, flowType: 'pkce' },
});
